export default [
    {
        key: 'ManMachineCheckModal',
        getComponent: function () { return import('./ManMachineCheckModal'); },
        maskClosable: false,
        title: '',
        width: 450
    },
    {
        key: 'ChangeAccountInfoModal',
        getComponent: function () { return import('./ChangeAccountInfoModal'); },
        maskClosable: false,
        title: '',
        width: 600
    },
    {
        key: 'ProtocolModal',
        getComponent: function () { return import('./ProtocolModal'); },
        maskClosable: false,
        title: '',
        width: 600,
        wrapClassName: ''
    },
    {
        key: 'Check2FactorAuthModal',
        getComponent: function () { return import('./Check2FactorAuthModal'); },
        maskClosable: false,
        title: '',
        width: 600,
        wrapClassName: ''
    },
    {
        key: 'ProtocolConfirmModal',
        getComponent: function () { return import('./ProtocolConfirm'); },
        width: 560,
        maskClosable: false,
        wrapClassName: '',
        enhancer: 'modal',
        enhancerOptions: {
            title: '',
            footer: [],
            className: 'custom-modal-layer',
        },
    }
];
